import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import WRPositionList from './WRPositionList';

const WRPositions = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Derechos de Agua', icon: 'icon-droplets' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Posiciones' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<WRPositionList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default WRPositions;
